import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Removes the custom `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#customlineitem"
        }}>{`CustomLineItem`}</a>{` from the cart.`}</p>
      <p parentName="section">{`Removing a custom line item does not support specifying a quantity, unlike the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#remove-lineitem"
        }}>{`removal of line items`}</a>{`. It's not possible to partially remove `}<inlineCode parentName="p">{`shippingDetails`}</inlineCode>{` using this update action. See `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#change-customlineitem-quantity"
        }}>{`Change CustomLineItem Quantity`}</a>{` for that.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"removeCustomLineItem"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`customLineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#customlineitem"
          }}>{`CustomLineItem`}</a>{` in the cart.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      